import {useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {InputTextWrapper, SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {useLimpieza} from '../../../../../../hooks/useLimpieza'
import {useCampaments} from '../../../../hooks/central/useCampaments'
import {useClients} from '../../../../hooks/central/useClients'
import {useCompanies} from '../../../../hooks/central/useCompanies'
import {useParameters} from '../../../../hooks/central/useParameters'
import {useSites} from '../../../../hooks/central/useSites'
import {CREATION_CELLPHONES_SERVICES} from '../../../../services'

export const CreationCellphonesForm = () => {
  const {setError, setValue, watch} = useFormContext()

  const {currentTabItem} = useLimpieza()
  const {getCompanies, companies, clearCompanies} = useCompanies()
  const {getClients, clients, clearClients} = useClients()
  const {getSites, sites, clearSites} = useSites()
  const {getCampaments, campaments, clearCampaments} = useCampaments()
  const {getStatusCellphones, getSuppliersCellphones, statusCellphones, suppliersCellphones} =
    useParameters()

  useEffect(() => {
    getCompanies({isCombo: true}, 1)
    getStatusCellphones(
      {pageNumber: 1, size: 200, tableName: 'ESTADOCELULAR'},
      {},
      {idKey: 'codigo', labelKey: 'nombreCorto'},
    )
    getSuppliersCellphones(
      {pageNumber: 1, size: 200, tableName: 'PROVCELULARES'},
      {},
      {idKey: 'codigo', labelKey: 'nombreCorto'},
    )
    setValue('Estado', 'ACT')
    return () => {
      clearCompanies()
      clearClients()
      clearSites()
      clearCampaments()
    }
  }, [])

  useEffect(() => {
    if (companies.length === 1) {
      setValue('CompaniaId', companies[0].value)
      setError('CompaniaId', {})
      getClients({isCombo: true, companiaId: companies[0].value}, 1)
    }
  }, [companies])

  useEffect(() => {
    if (clients.length === 1) {
      setValue('ClienteId', clients[0].value)
      setError('ClienteId', {})
      getSites({isCombo: true, clienteId: clients[0].value}, 1)
    }
  }, [clients])

  useEffect(() => {
    if (sites.length === 1) {
      setValue('SiteId', sites[0].value)
      setError('SiteId', {})
      getCampaments({isCombo: true, siteId: sites[0].value}, 1)
    }
  }, [sites])

  useEffect(() => {
    if (campaments.length === 1) {
      setValue('CampamentoId', campaments[0].value)
      setError('CampamentoId', {})
    }
  }, [campaments])

  const getCellphoneById = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await CREATION_CELLPHONES_SERVICES.getCellphoneById(idToEdit)
        if (data) {
          console.log('data', data)
          const {
            CampamentoId,
            SiteId,
            CompaniaId,
            ClienteId,
            NroCelular,
            ProveedorServicio,
            Marca,
            Modelo,
            NroSerie,
            Estado,
          } = data

          setValue('Id', idToEdit)
          setValue('CampamentoId', CampamentoId)
          setValue('CompaniaId', CompaniaId)
          setValue('ClienteId', ClienteId)
          setValue('SiteId', SiteId)
          setValue('NroCelular', NroCelular)
          setValue('ProveedorServicio', ProveedorServicio)
          setValue('Marca', Marca)
          setValue('Modelo', Modelo)
          setValue('NroSerie', NroSerie)
          setValue('Estado', Estado)
          getClients({isCombo: true, companiaId: CompaniaId}, 1)
          getSites({isCombo: true, clienteId: ClienteId}, 1)
          getCampaments({isCombo: true, siteId: SiteId}, 1)
        }
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getCellphoneById()
    }
  }, [currentTabItem.idToEdit])

  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    clearSites()
    setValue('CampamentoId', '')
    clearCampaments()
    setError('CompaniaId', {})
    clearClients()
    getClients({isCombo: true, companiaId: value}, 1)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ClienteId', value)
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    clearSites()
    clearCampaments()
    setError('ClienteId', {})
    getSites({isCombo: true, clienteId: value}, 1)
  }

  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('SiteId', value)
    setValue('CampamentoId', '')
    setError('SiteId', {})
    clearCampaments()
    getCampaments({isCombo: true, siteId: value}, 1)
  }

  let isDisabled = currentTabItem.idToEdit ? true : false

  return (
    <ContentForm isEdit={isDisabled} title='Datos del Celular'>
      <div className='sdx_form card p-4'>
        <div className='d-flex row'>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Compañia'
              name='CompaniaId'
              data={companies}
              onChangeValue={handleCompanyChange}
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Cliente'
              name='ClienteId'
              data={clients}
              onChangeValue={handleClientChange}
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Site'
              name='SiteId'
              data={sites}
              onChangeValue={handleSiteChange}
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <InputTextWrapper
              labelText='Número de Celular'
              name='NroCelular'
              textPlaceholder='Escribe el Numero de Celular'
              required
              maxLength={9}
              type='numeric'
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Proveedor Servicio'
              name='ProveedorServicio'
              data={suppliersCellphones}
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <InputTextWrapper
              labelText='Modelo'
              name='Modelo'
              textPlaceholder='Escribe el Modelo'
              maxLength={20}
              type='alphaNumeric'
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <InputTextWrapper
              labelText='Marca'
              name='Marca'
              textPlaceholder='Escribe la Marca'
              maxLength={20}
              type='alphaNumeric'
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <InputTextWrapper
              labelText='Nro de Serie'
              name='NroSerie'
              textPlaceholder='Escribe el Nro de Serie'
              type='alphaNumeric'
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper labelText='Estado' name='Estado' data={statusCellphones} required />
          </div>
        </div>
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </div>
    </ContentForm>
  )
}
